import * as soundFiles from 'core/constants/sound';
import { getRandomItem } from 'core/utils/logic';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  getOption,
  MUSIC_MUTED,
  MUSIC_VOLUME,
  SOUND_EFFECTS_MUTED,
  SOUND_EFFECTS_VOLUME,
} from 'reducer/options';

export const useMusicVolume = () => {
  const musicMuted = useSelector(getOption(MUSIC_MUTED));
  const musicVolume = useSelector(getOption(MUSIC_VOLUME));
  return musicMuted ? 0 : musicVolume / 100 / 1.5;
};

export const useSoundEffectsVolume = () => {
  const soundEffectsMuted = useSelector(getOption(SOUND_EFFECTS_MUTED));
  const soundEffectsVolume = useSelector(getOption(SOUND_EFFECTS_VOLUME));
  return soundEffectsMuted ? 0 : soundEffectsVolume / 100 / 5;
};

export const usePlaySoundEffect = () => {
  const soundEffectsVolume = useSoundEffectsVolume();
  return (url) => {
    if (url && soundEffectsVolume > 0) {
      const soundEffect = new Audio(url);
      soundEffect.volume = soundEffectsVolume;
      soundEffect.play();
    }
  };
};

export const usePlayRandomSoundEffect = () => {
  const playSoundEffect = usePlaySoundEffect();
  return (listOfSounds) => {
    const randomSound = getRandomItem(listOfSounds);
    playSoundEffect(randomSound);
  };
};

export const usePlaySoundEffectFromApi = (apiSounds, gameState) => {
  const playRandomSoundEffect = usePlayRandomSoundEffect();
  const modalState = useRef(null);
  useEffect(() => {
    if (modalState.current !== gameState && apiSounds?.length > 0) {
      apiSounds.forEach((sounds, i) => {
        modalState.current = gameState;
        setTimeout(() => {
          playRandomSoundEffect(soundFiles[sounds]);
        }, i * 2000);
      });
    }
  }, [apiSounds, playRandomSoundEffect]);
};
